module.exports = __webpack_public_path__ + "img/item9.f46273f8.png";